import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { getSettingBrandSelfServeOrdersPayments } from "@faire/help-center-utils/settings/getSettingBrandSelfServeOrdersPayments";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Button as ButtonIcon } from "@faire/web/slate/icons/foundation/Button";
import { Link } from "@faire/web/slate/icons/foundation/Link";
import React from "react";
export var useFaireDirectBrandNodes = function useFaireDirectBrandNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    FaireDirect: {
      id: "FaireDirect",
      label: strictLocalize({
        id: "+Rdcct",
        defaultMessage: [{
          "type": 0,
          "value": "Faire Direct"
        }]
      }),
      icon: getSettingBrandSelfServeOrdersPayments() ? ( /*#__PURE__*/React.createElement(Link, {
        fontSize: "24px",
        color: "faireBlack"
      })) : ( /*#__PURE__*/React.createElement(ButtonIcon, {
        fontSize: "24px",
        color: "faireBlack"
      })),
      articles: [articles.FaireDirect.ORDER_COMMISSION, articles.FaireDirect.FAIRE_DIRECT, articles.FaireDirect.FD_ELIGIBLE, articles.FaireDirect.FD_LINK],
      level: 1,
      sidebarTitle: strictLocalize({
        id: "aaCorN",
        defaultMessage: [{
          "type": 0,
          "value": "Faire Direct-probleem"
        }]
      })
    }
  };
};